import classNames from 'classnames'
import { useMemo } from 'react'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Text } from '@ds'
import { UserAvatar } from '@shared'

import styles from './BottomPanel.module.scss'
import { RefyIcon } from './icons/RefyIcon'

type Props = {
  tapsLeft: number
  tapsTotal: number
  refillDate: string
  taplapsTime: string
}

function getNextRefillTime(refillDate: string, taplapsTime: string): Date {
  const lastRefill = new Date(refillDate)
  const boostEnd = new Date(taplapsTime)

  let nextRefill = new Date(lastRefill.getTime() + 30 * 60 * 1000)

  if (lastRefill >= boostEnd) {
    nextRefill = new Date(lastRefill.getTime() + 60 * 60 * 1000)
  }

  if (lastRefill < boostEnd && nextRefill > boostEnd) {
    nextRefill = new Date(lastRefill.getTime() + 60 * 60 * 1000)
  }

  return nextRefill
}

const ONE_MINUTE = 60 * 1000
const UPDATE_TYPE = 0 // 0 - sec, 1 - 100ms, 2 - 10ms, 3 - 1ms

export const BottomPanel = ({
  tapsLeft,
  tapsTotal,
  refillDate,
  taplapsTime,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const tapsWidth = useMemo(
    () =>
      (tapsLeft * 100) / tapsTotal > 100 ? 100 : (tapsLeft * 100) / tapsTotal,
    [tapsLeft, tapsTotal]
  )

  const nextTapTime = getNextRefillTime(refillDate, taplapsTime)

  const renderer = ({ minutes, completed }: any) => {
    if (completed || tapsLeft >= tapsTotal) {
      return (
        <div>
          <Text className={styles.font}>Full</Text>
          <Text className={styles.font} type="ghost">
            charged
          </Text>
        </div>
      )
    }

    return (
      <div className={styles.time}>
        <span className={styles.oneRow}>
          <Text className={styles.font} center>
            +1
          </Text>
          <Text className={styles.font} center type="ghost">
            {t('home.tap')}
          </Text>
        </span>
        <span className={styles.oneRow}>
          <Text type="body-3" center>
            {minutes}
          </Text>
          <Text className={styles.font} center type="ghost">
            {t('home.min')}
          </Text>
        </span>
      </div>
    )
  }

  return (
    <div className={styles.bottom}>
      <div className={classNames([styles.avatar])}>
        <UserAvatar size={40} className={styles.avatarContainer} />
        {/* <div className={classNames([styles.notification])}></div> */}
      </div>
      <div className={styles.taps}>
        <div className={styles.tapsText}>{t('home.tapsLeft')}</div>
        <div className={styles.count}>{tapsLeft}</div>
        <div className={classNames([styles.refill])}>
          <Countdown
            date={nextTapTime}
            intervalDelay={ONE_MINUTE}
            precision={UPDATE_TYPE}
            renderer={renderer}
          />
        </div>
        <div className={styles.progress}>
          <div
            className={styles.progressBar}
            style={{ width: `${tapsWidth}%` }}
          />
          <div className={styles.dividers}>
            {Array.from({ length: tapsTotal - 1 }).map((_, i) => (
              <div
                key={i}
                className={styles.divider}
                style={{
                  left: `${((i + 1) / tapsTotal) * 100}%`,
                }}
              />
            ))}
          </div>
        </div>
      </div>



      <button
        className={styles.refButton}
        onClick={() => navigate('/referrals')}
      >
        <RefyIcon className={styles.refButtonBall} />
        <span className={styles.refButtonText}>Referrals</span>
      </button>
    </div>
  )
}
